import { ListItemIcon } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Stack, style, Text, palette } from '@solvhealth/jigsaw';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../constants/colors';

const ActionText = styled(Text)<{ $isTextLink: Boolean }>`
  ${(props) => css`
    color: ${props.$isTextLink && colors.blueJayWay};
  `}
`;

const ActionIcon = styled.img`
  width: 50px;
`;

const ActionItem = styled(ListItem)(
  style({
    py: 2,
    pl: 3,
    pr: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  })
);

type Props = {
  icon?: string;
  actionText?: ReactNode;
  showArrow?: boolean;
  id?: string;
  onClick?: (...args: any[]) => any;
  isTextLink?: boolean;
};

const DrawerAction: React.FC<Props> = (props: Props) => {
  const { actionText, showArrow = true, id, onClick, isTextLink = false, icon } = props;
  return (
    <ActionItem button dense key={id} onClick={onClick}>
      <Stack alignItems="center" justifyContent="flex-start" row space={2}>
        {icon && <ActionIcon src={icon} />}
        <ActionText $isTextLink={isTextLink} maxWidth={270}>
          {actionText}
        </ActionText>
      </Stack>
      {showArrow && <ChevronRightIcon style={{ color: palette.gray[600] }} />}
    </ActionItem>
  );
};

export default DrawerAction;
